import { Component, Input } from '@angular/core';

import { CoreMenuItem } from '@core/types';

@Component({
  selector: '[core-menu-vertical-item]',
  templateUrl: './item.component.html'
})
export class CoreMenuVerticalItemComponent {
  @Input()
  item: CoreMenuItem;
  
  @Input()
  currentUser: any;

  isRoleAllowed(itemRoles,title): boolean {
    if(itemRoles){
    return itemRoles.some(role => this.currentUser?.roles.includes(role));
    }
    else
    return true;
  }
}
